import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { SourcePersonaOption } from '@app/v2/event/types/add-from-other-event.type'

@Component({
  selector: 'app-source-persona-option',
  standalone: true,
  templateUrl: './source-persona-option.component.html',
  host: {
    class: 'tw-flex tw-min-w-0 tw-items-center tw-gap-3 tw-text-start tw-font-inter'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourcePersonaOptionComponent {
  public readonly option = input.required<SourcePersonaOption>()
}
